import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { GoAndTrackLink } from "../../lib/goAndTrack";

const COLS = [
  {
    heading: "Category",
    links: [
      { to: "/disposable-package-tracker", label: "Disposable Package Tracker" },
      { to: "/disposable-smart-labels", label: "Disposable Smart Labels" },
      { to: "/disposable-gps-tracker", label: "Disposable GPS Tracker" },
      { to: "/gps-tracker-for-packages", label: "GPS Tracker for Packages" },
      { to: "/bluetooth-smart-labels", label: "Bluetooth Smart Labels" },
      { to: "/disposable-vs-reusable-trackers", label: "Disposable vs Reusable" },
    ],
  },
  {
    heading: "Learn",
    links: [
      { to: "/how-disposable-trackers-work", label: "How they work" },
      { to: "/gps-vs-ble-vs-cellular", label: "GPS vs BLE vs Cellular" },
      { to: "/disposable-tracking-cost", label: "Cost of tracking" },
      { to: "/glossary", label: "Glossary" },
      { to: "/faqs", label: "FAQs" },
    ],
  },
  {
    heading: "Use cases",
    links: [
      { to: "/smart-labels-for-logistics", label: "Logistics" },
      { to: "/smart-labels-for-high-value-shipments", label: "High-Value Shipments" },
      { to: "/smart-labels-for-pilot-projects", label: "Pilot Projects" },
    ],
  },
  {
    heading: "Programme",
    links: [
      { to: "/about", label: "About" },
      { to: "/request-a-trial", label: "Speak to an expert" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-line bg-surface-subtle mt-24"
    >
      <div className="container-x py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="h-9 w-9 grid place-items-center bg-ink text-white font-mono text-[11px] tracking-widest">
                DSL
              </span>
              <span className="font-heading font-semibold text-ink">
                Disposable Smart Labels
              </span>
            </div>
            <p className="body-text mt-6 max-w-md">
              Single-use smart labels for high-value shipments, temporary
              tracking, logistics pilots, and package visibility. Operational
              visibility delivered through <GoAndTrackLink />.
            </p>
          </div>

          {COLS.map((col) => (
            <div key={col.heading} className="lg:col-span-2">
              <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-subtle mb-5">
                {col.heading}
              </p>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-ink-muted hover:text-brand transition-colors"
                      data-testid={`footer-link-${l.to.replace(/\//g, "")}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1 flex lg:justify-end">
            <Link
              to="/request-a-trial"
              className="btn-primary text-sm h-fit"
              data-testid="footer-cta"
            >
              Speak to an expert <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-line">
        <div className="container-x py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-ink-subtle">
          <p>
            © {new Date().getFullYear()} Disposable Smart Labels. All rights
            reserved. Operational visibility powered by <GoAndTrackLink />.
          </p>
          <div className="flex gap-5">
            <Link to="/faqs" className="hover:text-ink" data-testid="footer-legal-faqs">
              FAQs
            </Link>
            <a href="#privacy" className="hover:text-ink" data-testid="footer-legal-privacy">
              Privacy
            </a>
            <a href="#terms" className="hover:text-ink" data-testid="footer-legal-terms">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
